import { Directive, HostBinding, HostListener, Input } from '@angular/core';
import { RecognizedSupplierService } from 'src/app/modules/payable/services/recognized-supplier.service';

/**
 * A supplier's name that opens the supplier panel (details, transactions, activity) over
 * whatever panel it sits in. Without an id it is plain text.
 *
 *   <span [appOpenSupplier]="invoice.supplierId">{{ invoice.supplierName }}</span>
 */
@Directive({
  selector: '[appOpenSupplier]'
})
export class OpenSupplierDirective {
  @Input('appOpenSupplier') supplierId: string;

  constructor(private recognizedSupplier: RecognizedSupplierService) { }

  @HostBinding('class.open-supplier') get isLink(): boolean { return !!this.supplierId; }
  @HostBinding('attr.role') get role(): string { return this.supplierId ? 'link' : null; }
  @HostBinding('attr.tabindex') get tabindex(): number { return this.supplierId ? 0 : null; }
  @HostBinding('attr.title') get title(): string { return this.supplierId ? 'Open supplier' : null; }

  @HostListener('click', ['$event'])
  @HostListener('keydown.enter', ['$event'])
  open(event: Event): void {
    if (!this.supplierId) { return; }
    event.stopPropagation();
    event.preventDefault();
    this.recognizedSupplier.openSupplierPanel(this.supplierId);
  }
}
